/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Resume_Perf_EmptyInputs */

const en_analytics_resume_perf_empty = /** @type {(inputs: Analytics_Resume_Perf_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No resume performance data yet.`)
};

const de_analytics_resume_perf_empty = /** @type {(inputs: Analytics_Resume_Perf_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Lebenslauf-Leistungsdaten.`)
};

const fr_analytics_resume_perf_empty = /** @type {(inputs: Analytics_Resume_Perf_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune donnée de performance de CV pour le moment.`)
};

const es_analytics_resume_perf_empty = /** @type {(inputs: Analytics_Resume_Perf_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no hay datos de rendimiento de currículum.`)
};

const it_analytics_resume_perf_empty = /** @type {(inputs: Analytics_Resume_Perf_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun dato sulle prestazioni del curriculum ancora.`)
};

const nl_analytics_resume_perf_empty = /** @type {(inputs: Analytics_Resume_Perf_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog geen CV-prestatiegegevens.`)
};

const pl_analytics_resume_perf_empty = /** @type {(inputs: Analytics_Resume_Perf_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak danych o skuteczności CV.`)
};

const fi_analytics_resume_perf_empty = /** @type {(inputs: Analytics_Resume_Perf_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei vielä ansioluettelon suorituskykytietoja.`)
};

const da_analytics_resume_perf_empty = /** @type {(inputs: Analytics_Resume_Perf_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen CV-performancedata endnu.`)
};

const sv_analytics_resume_perf_empty = /** @type {(inputs: Analytics_Resume_Perf_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen CV-prestandadata ännu.`)
};

/**
* | output |
* | --- |
* | "No resume performance data yet." |
*
* @param {Analytics_Resume_Perf_EmptyInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const analytics_resume_perf_empty = /** @type {((inputs?: Analytics_Resume_Perf_EmptyInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Resume_Perf_EmptyInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_analytics_resume_perf_empty(inputs)
	if (locale === "fr") return fr_analytics_resume_perf_empty(inputs)
	if (locale === "es") return es_analytics_resume_perf_empty(inputs)
	if (locale === "it") return it_analytics_resume_perf_empty(inputs)
	if (locale === "nl") return nl_analytics_resume_perf_empty(inputs)
	if (locale === "pl") return pl_analytics_resume_perf_empty(inputs)
	if (locale === "fi") return fi_analytics_resume_perf_empty(inputs)
	if (locale === "da") return da_analytics_resume_perf_empty(inputs)
	if (locale === "sv") return sv_analytics_resume_perf_empty(inputs)
	return en_analytics_resume_perf_empty(inputs)
});